
import moment from 'moment';
import { isEmpty } from "lodash";

import InvoiceService from '../services/InvoiceService';
import LocalStorageService from '../services/LocalStorageService';
import Invoice from '../model/invoicing/Invoice';
import EventDispatcher from "../framework/EventDispatcher";
import FileService from "../services/FileService";
import chargeInstanceService from "../services/ChargeInstanceService";

export const GET_INVOICE_LIST = "GET_INVOICE_LIST";
export const FETCH_MYINVOICES = "FETCH_MYINVOICES";
export const GET_PDF_INVOICE_BY_FILENAME = "GET_PDF_INVOICE_BY_FILENAME";
export const GET_PDF_INVOICE_BY_ID = "GET_PDF_INVOICE_BY_ID";
export const GET_FILE = "GET_FILE";
export const GET_INVOICES_DATES = "GET_INVOICES_DATES";

export default function reducer(state = {user: null}, action = {}) {
	switch (action.type) {
		case EventDispatcher.successAction(GET_INVOICE_LIST):
			const {list} = action.data;
			return {
				...state,
				invoices: list
			};
			break;
		case EventDispatcher.successAction(GET_FILE):
			const {file} = action.data;
			return {
				...state,
				allFiles: file
			};
			break;
		case EventDispatcher.successAction(FETCH_MYINVOICES):
			const {myInvoices} = action.data
			return {
				...state,
				myInvoices: myInvoices
			};
			break;
		case EventDispatcher.successAction(GET_INVOICES_DATES):
			const {nextInvoiceDate, dueDate} = action.data;
			return {
				...state,
				nextInvoiceDate,
				dueDate
			};
			break;
		default:
			return state;
	}
}

export function getPdfInvoiceByFileName(fileName) {
	return dispatch => {
		EventDispatcher.loading(dispatch, GET_PDF_INVOICE_BY_FILENAME);
		FileService.downloadFile("type=invoice&encoding=base64&path=invoices/pdf/" + fileName);
		EventDispatcher.success(dispatch, GET_PDF_INVOICE_BY_FILENAME);
	}
}

export function getPdfContratByFileName(fileName) {
	return dispatch => {
		EventDispatcher.loading(dispatch, GET_PDF_INVOICE_BY_FILENAME);
		FileService.downloadFile("name=" + fileName + "&encoding=base64&path=" + DOCUMENT_PATH + fileName);
		EventDispatcher.success(dispatch, GET_PDF_INVOICE_BY_FILENAME);
	}
}

export function findFiles() {
	return dispatch => {
		EventDispatcher.loading(dispatch, GET_FILE);
		FileService.findFiles()
		.then(response => {
			const {actionStatus} = response;
			if (!actionStatus || actionStatus.status === "FAIL") {
				throw actionStatus;
			} else {
				const {file} = response;
					EventDispatcher.success(dispatch, GET_FILE, {file});
				}
			})
			.catch(error => {
				EventDispatcher.error(dispatch, GET_FILE, error);
			});
	};
}

export function getInvoiceList(accountCode) {
	return dispatch => {
		EventDispatcher.loading(dispatch, GET_INVOICE_LIST);
		let list = [];
		if (!accountCode) {
			EventDispatcher.success(dispatch, GET_INVOICE_LIST, {list});
		} else {
			InvoiceService.list(accountCode)
			.then(response => {
				const {actionStatus} = response;
				if (!actionStatus || actionStatus.status === "FAIL") {
					throw actionStatus;
				} else {
					const {CustomerInvoiceDtoList = []} = response;
					EventDispatcher.success(dispatch, GET_INVOICE_LIST, {
						list: CustomerInvoiceDtoList
					});
				}
			})
			.catch(error => {
				EventDispatcher.error(dispatch, GET_INVOICE_LIST, error);
			});
		}
	};
}

export function fetchMyInvoices(subscriptionCode) {
	return dispatch => {
		InvoiceService.listInvoicesBySubCode(subscriptionCode)
		.then(invoiceDto => {
			const {actionStatus} = invoiceDto;
			if (actionStatus == null || actionStatus.status === "FAIL") {
				this.fail(actionStatus);
			} else {
				const {invoices = []}  = invoiceDto;

				EventDispatcher.success(dispatch, FETCH_MYINVOICES, {
				  myInvoices: invoices.map(invoice => new Invoice(invoice))
				})
			}
		})
		.catch(error => {
			EventDispatcher.error(dispatch, FETCH_MYINVOICES, {error})
		});
	}
}

export function getPdfInvoiceByID(invoiceID) {
	return dispatch => {
		EventDispatcher.loading(dispatch, GET_PDF_INVOICE_BY_ID);
		InvoiceService.downloadPdf(invoiceID)
		.then(invoiceDto => {
			const {fileContent = "", fileName = ""}  = invoiceDto;
			const pdfName = fileName.split('/');
			const finalPdfName = pdfName[pdfName.length - 1];
			FileService.downloadPdf(finalPdfName, fileContent);
			EventDispatcher.success(dispatch, GET_PDF_INVOICE_BY_ID);
		})
		.catch(error => {
			EventDispatcher.error(dispatch, GET_PDF_INVOICE_BY_ID, {error})
		});
	}
}

export function fetchInvoicesDates(subscriptionCode) {
	return dispatch => {
		EventDispatcher.loading(dispatch, GET_INVOICES_DATES);
		chargeInstanceService.loadAll(
			{
				filters: {
					"chargeType": "R",
					"subscription.status": "ACTIVE",
					"subscription.code": subscriptionCode,
				},
				nestedEntities: [
					"subscription"
				],
				genericFields: [
					"subscription",
					"subscription.subscribedTillDate",
					"nextChargeDate"
				]
			}
		)
		.then(response => {
			const now = new Date();
			const { data = []} = response;
			const nextChargeDate = data
				.filter(chargeInstance => chargeInstance.subscription && !chargeInstance.subscription.subscribedTillDate)
				.map(chargeInstance => new Date(chargeInstance.nextChargeDate))
				.filter(nextChargeDate => nextChargeDate >= now)
				.sort(function (date1, date2) {
					let dist1 = date1 - now;
					let dist2 = date2 - now;
					return dist1 - dist2;
				});
			let nextInvoiceDate = "";
			let dueDate = "";
			if (!isEmpty(nextChargeDate)) {
				nextInvoiceDate = nextChargeDate[0];
				dueDate = new Date(nextInvoiceDate.getFullYear(), nextInvoiceDate.getMonth(), nextInvoiceDate.getDate() + numberOfDay);
				const itsHolyday = joursFeries.find(jf => jf === moment(dueDate).format("DD/MM"));
				while (dueDate.getDay() === 0 || dueDate.getDay() === 6 || !!itsHolyday) {
					dueDate = new Date(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate() + 1);
				}
			}
			EventDispatcher.success(dispatch, GET_INVOICES_DATES, {nextInvoiceDate, dueDate});
		})
		.catch(error => {
			EventDispatcher.error(dispatch, GET_INVOICES_DATES, {error})
		});
	}
}



// WEBPACK FOOTER //
// ./src/opencell/actions/InvoiceActions.js